/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "history", "simple-query-string", "../FluxCommon/Actions", "../FluxCommon/ActionsHubManager", "./SelectionActions"], function (require, exports, history_1, queryString, Actions_1, ActionsHubManager_1, SelectionActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SelectionActionsCreator = /** @class */ (function (_super) {
        __extends(SelectionActionsCreator, _super);
        function SelectionActionsCreator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SelectionActionsCreator.getKey = function () {
            return "selection-actionscreator";
        };
        SelectionActionsCreator.prototype.initialize = function (instanceId) {
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(SelectionActions_1.SelectionActions);
        };
        SelectionActionsCreator.prototype.selectItem = function (payload) {
            // Create history service fresh here, because we need the fresh url location
            // Unlike components, action creators are not re initialized on view mount
            var historyService = history_1.createBrowserHistory();
            var routeValues = __assign({}, queryString.parse(historyService.location.search));
            routeValues["type"] = payload.selectedItemType;
            routeValues["uid"] = payload.itemUID;
            if (!!payload.selectedItemType) {
                delete routeValues["view"];
            }
            // This logic needs some refining. We need to plan a course of action that will suit an open source hosting. The host might have its own query parameters
            // So, our design should be careful in handling those
            if (payload.properties) {
                // Add all the non-object, non-function and defined values to the url route. This will be read by the view loading itself
                Object.keys(payload.properties).forEach(function (k) {
                    var value = payload.properties[k];
                    if (!!value && typeof value !== "object" && typeof value !== "function") {
                        routeValues[k] = value;
                    }
                    // We will send undefined or empty for values that we want deleted from the url
                    if (!value) {
                        delete routeValues[k];
                    }
                });
            }
            historyService.push({
                pathname: historyService.location.pathname,
                search: queryString.stringify(routeValues)
            });
            this._actions.selectItem.invoke(payload);
        };
        return SelectionActionsCreator;
    }(Actions_1.ActionCreatorBase));
    exports.SelectionActionsCreator = SelectionActionsCreator;
});
